import { render } from "./ContactComponent.vue?vue&type=template&id=eca2ee6c"
import script from "./ContactComponent.vue?vue&type=script&lang=js"
export * from "./ContactComponent.vue?vue&type=script&lang=js"

import "./ContactComponent.vue?vue&type=style&index=0&id=eca2ee6c&lang=css"

import exportComponent from "/Users/alejandrobernal/Documents/fbc/fbc-ecommerce-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__